<template>
  <header class="datatable__header">
    <dr-autocomplete
      class="form-group col-4"
      v-for="(filter, $index) of filters"
      :options.sync="localFilters[filter.name]"
      :name="$index"
      :label="filter.label"
      @autocompleted="autocompleted($event)"
      :key="$index">
    </dr-autocomplete>
  </header>
</template>

<script>
import drAutocomplete from '@/components/form/autocomplete'
export default {
  props: [
    'filters'
  ],
  components: {
    drAutocomplete
  },
  data () {
    return {
      autocompletes: {},
      loaded: false,
      showSelect: null,
      updateTable: false,
      parentComponent: '',
      selectedCustomer: null,
      availableEvents: [],
      selectedEvent: '',
      localFilters: {},
      showCustomers: false
    }
  },
  mounted () {
    for (let filter in this.filters) {
      this.autocompletes[filter] = ''
      this.localFilters[filter] = {}
      let i = 0
      for (let option of this.filters[filter].values) {
        option = option.toUpperCase()
        this.localFilters[filter][i++] = option
      }
    }
    this.loaded = true
  },
  methods: {
    autocompleted (ev) {
      this.$emit('updateFilter', { name: ev.name, value: ev.value })
    }
  }
}
</script>
